import Vue from 'vue'

import api from '@/helpers/api'
import router from '@/router';
const defineAbilitiesFor = require('@/helpers/ability');

const getDefaultState = () => {
  return {
    user: {},
    error: { type: '', message: '' }
  }
}

const state = getDefaultState()

const getters = {
  user: (state, getters, rootState) => {
    return state.user
  },
  error: (state, getters, rootState) => {
    return state.error
  }
}

const actions = {
  login ({commit, dispatch}, data){

    api.post('/login', data).then(response => {
      if(response.token){
        let user = response.user
        // localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('token', response.token)
        commit('setUser', user)
        // let ability = defineAbilitiesFor(user)
        // Vue.use(abilitiesPlugin, ability);
        //router.push('/dashboard')
        router.go('/dashboard')
      }
    }, error => {
      commit('Error', { message: error.message, type: 'danger' })
    })
  },
  resetUserState ({ commit }) {
    commit('resetState')
  },
  setUser({commit}, user){
    commit('setUser', user)
  }
}

const mutations = {
  setUser (state, user) {
    state.user = user
  },
  Error (state, error) {
    state.error = error
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
